// extracted by mini-css-extract-plugin
module.exports = {"page":"style_page__3sAdT","sorryContainer":"style_sorryContainer__3wR44","sorryImg":"style_sorryImg__1figM"};